export default {"src":"/_next/static/media/okta.dbcd2860.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};